import React, {useEffect, useState} from "react";
import Select from "../ui-components/Select";
import {useIntl} from "react-intl";
import {FIELDS as connettori_FIELDS} from "../feature/services/connettori";
import {FIELDS as nodi_FIELDS} from "../feature/services/rinforzo-nodo";
import {FIELDS as kcolorFields} from "@feature/kcolor/kcolor-input";
const COMPOSITE_QUESTIONS_TYPES = [
  "connector_input", "node_reinforcement_input", "k_color_input"
];

const ServiceConfiguratorCompositeQuestionFieldSelector = ({
  label,
  selectedQuestionId,
  questions,
  onChange,
  value,
  numericFieldsOnly = false,
  disabled = false,
}) => {

  // hooks
  const intl = useIntl();

  // state
  const [options, setOptions] = useState();

  useEffect(() => {
    const selected = questions.find(({id}) => id === selectedQuestionId);
    if (!COMPOSITE_QUESTIONS_TYPES.includes(selected?.input_type)) {
      setOptions(undefined);
    }
    else {
      let fields;
      switch (selected.input_type) {
        case "connector_input":
          fields = connettori_FIELDS[selected.metadata_?.type];
          if (!fields)
           throw new Error(`Unhandled connector input type '${selected.metadata_?.type}'`);
          break;
        case "node_reinforcement_input":
          fields = nodi_FIELDS;
          if (!fields)
              throw new Error(`Unhandled node reinforcement input type '${selected.metadata_?.type}'`);
          break;
        case "k_color_input":
          fields = kcolorFields;
          if (!fields)
              throw new Error(`Unhandled node reinforcement input type '${selected.metadata_?.type}'`);
          break;
        default:
          throw new Error(`Unhandled input type '${selected.input_type}'`);
      }
      setOptions(
        Object.entries(fields || {})
          ?.filter(([, {numeric}]) => !numericFieldsOnly || numeric)
          ?.map(([key, {localization}]) => ({
            value: key,
            name: !!localization ? intl.formatMessage(localization) : key,
          }))
      );
    }
  }, [selectedQuestionId, questions]);  // eslint-disable-line react-hooks/exhaustive-deps
  
  if (!options)
    return null;

  return (
    <Select
      label={label}
      options={[
        { value: "", name: "" },
        ...options,
      ]}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  )
};

export default ServiceConfiguratorCompositeQuestionFieldSelector;
